import { TasklistService } from '@/api/tasklist';
import { Input, Select } from 'alurkerja-ui';
import { useNavigate } from 'react-router-dom';

export default function HeaderTableRequest({ title }: Readonly<{ title: string }>) {
  const navigate = useNavigate();

  /**
   * Fetch all business processes
   */
  const { data: businessProcesses, isFetching: isFetchingBusinessProcesses } = TasklistService.useGetProcesses();

  /**
   * Options for select field to filter by business process
   * First option is "All Processes" which will fetch all tasks
   * Other options are from the list of business processes
   * Each option has `label` which is the name of the business process
   * and `value` which is the key of the business process
   */
  const businessProcessesOptions: { label: string; value: string }[] = [
    {
      label: 'All Processes',
      value: 'all',
    },
    ...(businessProcesses?.map(businessProcess => ({
      label: businessProcess.name,
      value: businessProcess.key,
    })) || []),
  ];

  // handle filter
  const handleFilter = (value: string) => {
    if (value === 'all') {
      navigate(`?processKey=&page=`);
    } else {
      navigate(`?processKey=${value}&page=`, { replace: true });
    }
  };

  return (
    <div className="p-5 grid grid-cols-3">
      <div className="flex items-center">
        <h1 className="font-semibold uppercase">{title ?? 'Title'}</h1>
      </div>
      <div>
        <div>
          <Input size="xs" className="w-full !py-0 text-sm bg-slate-100 border-0" placeholder="Search something..." />
        </div>
      </div>
      <div className="flex justify-end items-center">
        <div className="flex items-center w-1/2">
          <Select
            placeholder="All Process"
            options={businessProcessesOptions}
            isLoading={isFetchingBusinessProcesses}
            isSearchable={false}
            onChange={e => {
              handleFilter((e as { value: string }).value);
            }}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
}
